import { Encoding } from "./encoding";

export class Encoder {
  private _encoding: Encoding;

  private _bom: Uint8Array | null;

  constructor(encoding: Encoding, bom: Uint8Array | null) {
    this._encoding = encoding;
    this._bom = bom;
  }

  encode(data: string): Uint8Array {
    const enc = this._encoding;
    if (enc === Encoding.UTF32LE || enc === Encoding.UTF32BE)
      throw new Error("UTF32 encoding not supported in browser");

    let arr: Uint8Array;
    switch (enc) {
      case Encoding.UTF16BE:
        arr = encodeUTF16(data, true);
        break;
      case Encoding.UTF16LE:
        arr = encodeUTF16(data, false);
        break;
      case Encoding.UTF8:
        arr = new TextEncoder().encode(data);
        break;
      default:
        throw new Error("Invalid encoding");
    }

    if (this._bom) return prependBom(this._bom, arr);
    return arr;
  }
}

function prependBom(bom: Uint8Array, content: Uint8Array): Uint8Array {
  const result = new Uint8Array(bom.length + content.length);
  result.set(bom, 0);
  result.set(content, bom.length);
  return result;
}

function encodeUTF16(data: string, bigEndian: boolean): Uint8Array {
  const encoder = new TextEncoder();
  const utf8Bytes = encoder.encode(data);
  const utf16Bytes = new Uint8Array(utf8Bytes.length * 2);

  for (let i = 0; i < utf8Bytes.length; i += 1) {
    if (bigEndian) {
      utf16Bytes[i * 2] = 0;
      utf16Bytes[i * 2 + 1] = utf8Bytes[i];
    } else {
      utf16Bytes[i * 2] = utf8Bytes[i];
      utf16Bytes[i * 2 + 1] = 0;
    }
  }

  return utf16Bytes;
}
